import _classCallCheck from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __accessCheck = function __accessCheck(obj, member, msg) {
  if (!member.has(obj)) throw TypeError("Cannot " + msg);
};

var __privateGet = function __privateGet(obj, member, getter) {
  __accessCheck(obj, member, "read from private field");

  return getter ? getter.call(obj) : member.get(obj);
};

var __privateAdd = function __privateAdd(obj, member, value) {
  if (member.has(obj)) throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};

var __privateSet = function __privateSet(obj, member, value, setter) {
  __accessCheck(obj, member, "write to private field");

  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};

var _mediaController;

import { MediaUIAttributes, MediaUIEvents, MediaStateReceiverAttributes, PointerTypes } from "./constants.js";
import { closestComposedNode, getBooleanAttr, setBooleanAttr } from "./utils/element-utils.js";
import { globalThis, document } from "./utils/server-safe-globals.js";
var template = document.createElement("template");
template.innerHTML = "\n<style>\n  :host {\n    display: var(--media-control-display, var(--media-gesture-receiver-display, inline-block));\n    box-sizing: border-box;\n  }\n</style>\n";

var MediaGestureReceiver = /*#__PURE__*/function (_globalThis$HTMLEleme) {
  _inherits(MediaGestureReceiver, _globalThis$HTMLEleme);

  var _super = _createSuper(MediaGestureReceiver);

  function MediaGestureReceiver() {
    var _this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, MediaGestureReceiver);

    _this = _super.call(this);

    __privateAdd(_assertThisInitialized(_this), _mediaController, void 0);

    if (!_this.shadowRoot) {
      var shadow = _this.attachShadow({
        mode: "open"
      });

      var buttonHTML = template.content.cloneNode(true);
      _this.nativeEl = buttonHTML;
      var slotTemplate = options.slotTemplate;

      if (!slotTemplate) {
        slotTemplate = document.createElement("template");
        slotTemplate.innerHTML = "<slot>".concat(options.defaultContent || "", "</slot>");
      }

      _this.nativeEl.appendChild(slotTemplate.content.cloneNode(true));

      shadow.appendChild(buttonHTML);
    }

    return _this;
  }

  _createClass(MediaGestureReceiver, [{
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(attrName, oldValue, newValue) {
      var _a, _b, _c, _d, _e;

      if (attrName === MediaStateReceiverAttributes.MEDIA_CONTROLLER) {
        if (oldValue) {
          (_b = (_a = __privateGet(this, _mediaController)) == null ? void 0 : _a.unassociateElement) == null ? void 0 : _b.call(_a, this);

          __privateSet(this, _mediaController, null);
        }

        if (newValue && this.isConnected) {
          __privateSet(this, _mediaController, (_c = this.getRootNode()) == null ? void 0 : _c.getElementById(newValue));

          (_e = (_d = __privateGet(this, _mediaController)) == null ? void 0 : _d.associateElement) == null ? void 0 : _e.call(_d, this);
        }
      }
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _a, _b, _c, _d;

      this.tabIndex = -1;
      this.setAttribute("aria-hidden", "true");

      __privateSet(this, _mediaController, getMediaControllerEl(this));

      if (this.getAttribute(MediaStateReceiverAttributes.MEDIA_CONTROLLER)) {
        (_b = (_a = __privateGet(this, _mediaController)) == null ? void 0 : _a.associateElement) == null ? void 0 : _b.call(_a, this);
      }

      (_c = __privateGet(this, _mediaController)) == null ? void 0 : _c.addEventListener("pointerdown", this);
      (_d = __privateGet(this, _mediaController)) == null ? void 0 : _d.addEventListener("click", this);
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      var _a, _b, _c, _d;

      if (this.getAttribute(MediaStateReceiverAttributes.MEDIA_CONTROLLER)) {
        (_b = (_a = __privateGet(this, _mediaController)) == null ? void 0 : _a.unassociateElement) == null ? void 0 : _b.call(_a, this);
      }

      (_c = __privateGet(this, _mediaController)) == null ? void 0 : _c.removeEventListener("pointerdown", this);
      (_d = __privateGet(this, _mediaController)) == null ? void 0 : _d.removeEventListener("click", this);

      __privateSet(this, _mediaController, null);
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(event) {
      var _a;

      var composedTarget = (_a = event.composedPath()) == null ? void 0 : _a[0];
      var allowList = ["video", "media-controller"];
      if (!allowList.includes(composedTarget == null ? void 0 : composedTarget.localName)) return;

      if (event.type === "pointerdown") {
        this._pointerType = event.pointerType;
      } else if (event.type === "click") {
        var clientX = event.clientX,
            clientY = event.clientY;

        var _this$getBoundingClie = this.getBoundingClientRect(),
            left = _this$getBoundingClie.left,
            top = _this$getBoundingClie.top,
            width = _this$getBoundingClie.width,
            height = _this$getBoundingClie.height;

        var x = clientX - left;
        var y = clientY - top;

        if (x < 0 || y < 0 || x > width || y > height || width === 0 && height === 0) {
          return;
        }

        var _event$pointerType = event.pointerType,
            pointerType = _event$pointerType === void 0 ? this._pointerType : _event$pointerType;
        this._pointerType = void 0;

        if (pointerType === PointerTypes.TOUCH) {
          this.handleTap(event);
          return;
        } else if (pointerType === PointerTypes.MOUSE) {
          this.handleMouseClick(event);
          return;
        }
      }
    }
  }, {
    key: "mediaPaused",
    get: function get() {
      return getBooleanAttr(this, MediaUIAttributes.MEDIA_PAUSED);
    },
    set: function set(value) {
      setBooleanAttr(this, MediaUIAttributes.MEDIA_PAUSED, value);
    }
  }, {
    key: "handleTap",
    value: function handleTap(e) {}
  }, {
    key: "handleMouseClick",
    value: function handleMouseClick(e) {
      var eventName = this.mediaPaused ? MediaUIEvents.MEDIA_PLAY_REQUEST : MediaUIEvents.MEDIA_PAUSE_REQUEST;
      this.dispatchEvent(new globalThis.CustomEvent(eventName, {
        composed: true,
        bubbles: true
      }));
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return [MediaStateReceiverAttributes.MEDIA_CONTROLLER, MediaUIAttributes.MEDIA_PAUSED];
    }
  }]);

  return MediaGestureReceiver;
}(globalThis.HTMLElement);

_mediaController = new WeakMap();

function getMediaControllerEl(controlEl) {
  var _a;

  var mediaControllerId = controlEl.getAttribute(MediaStateReceiverAttributes.MEDIA_CONTROLLER);

  if (mediaControllerId) {
    return (_a = controlEl.getRootNode()) == null ? void 0 : _a.getElementById(mediaControllerId);
  }

  return closestComposedNode(controlEl, "media-controller");
}

if (!globalThis.customElements.get("media-gesture-receiver")) {
  globalThis.customElements.define("media-gesture-receiver", MediaGestureReceiver);
}

var media_gesture_receiver_default = MediaGestureReceiver;
export { media_gesture_receiver_default as default };